module.exports = __webpack_public_path__ + "img/08.c13b1d30.jpg";